import { useState } from "react";
import SideDrawerOverlay from "../SideOverLay";
import { Button as MuiButton } from "../components/Common/Button";
import styles from "./index.module.scss";
import DownloadPopup from "../../pages/DownloadPopUp";
import { Button } from "../../common/components/Button";
import { getItemInLocalStorage } from "../../services/localStorage";
import Tooltip from "@mui/material/Tooltip";

const DownloadReport = ({
  open,
  onClose,
  onContinue,
  totalRecords = 20,
  valueSelected
}: {
  open: boolean;
  onClose: () => void;
  onContinue: (reportName: string, selected?: string) => void
  totalRecords?: number;
  valueSelected:string;
}) => {
  const filterResponse = getItemInLocalStorage("filterConfig");
  const reportOptions = filterResponse?.data?.reports?.options || [];


  const [selected, setSelected] = useState<string>("");
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);

  return (
    <>
      <SideDrawerOverlay
        open={open}
        grayLine={true}
        onClose={onClose}
        headerText="Download reports"
        footer={
          <>
            <MuiButton
              variant="outline"
              className={styles.cancelButton}
              onClick={onClose}
            >
              cancel
            </MuiButton>
            <Button
              buttonTextClassName={styles.saveButtonText}
              className={styles.saveButton}
              onClick={() => setShowDownloadPopup(true)}
              disable={!selected}
            >
              continue
            </Button>
          </>
        }
      >
        <div>
          <p className={styles.downloadreportText}>
            {valueSelected === "all"
              ? "Complete list without any filters will be downloaded when you select a report below."
              : `${totalRecords} Seekers that match the applied filters will be downloaded when you select a report below.`}
          </p>
          <div className={styles.optionsContainer}>
            {reportOptions.map((opt) => (
              <div
                className={styles.option}
                key={opt.code}
                onClick={() => setSelected(opt.code)}
              >
                <input
                  type="radio"
                  checked={selected === opt.code}
                  readOnly
                  className={styles.radio}
                  style={{ marginRight: 10 }}
                />
                <span className={styles.optionText}>
                  <Tooltip title={opt.description || ""}arrow>
                    <span>{opt.label}</span>
                  </Tooltip>
                </span>
              </div>
            ))}
          </div>
        </div>
      </SideDrawerOverlay>
      {showDownloadPopup && (
        <DownloadPopup
          open={showDownloadPopup}
          onClose={() => setShowDownloadPopup(false)}
          selected={selected}
          setSelected={setSelected}
          onDownload={(reportName:string) => {
            onContinue(reportName, selected)
            setShowDownloadPopup(false);
          }}
        />
      )}
    </>
  );
};

export default DownloadReport;